import React, { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Loading,
  TitleController,
  Heading,
  BreakPoint,
} from '@pandiafi/design-system'

import { BulletinBoardDataLoader } from './BulletinBoardDataLoader'
import { ErrorHandler } from './BulletinBoardErrorHandler'
import { BulletinBoardList } from './BulletinBoardList'

import { View } from 'components'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

export const BulletinBoardView: React.FC = () => {
  const { t } = useTranslation(['common', 'titles'])
  const { frontPagePath } = useContractPaths()

  return (
    <TitleController title={t('titles:bulletinBoard')}>
      <View>
        <View.Header>
          <View.HeaderLink to={frontPagePath}>
            {t('common:views.home')}
          </View.HeaderLink>

          <View.HeaderTitle>{t('common:views.bulletinBoard')}</View.HeaderTitle>
        </View.Header>

        <View.Sidebar />

        <View.Content>
          <>
            <BreakPoint show desktop>
              <Heading element="h1" size="xl" semibold className="mb-8">
                {t('common:views.bulletinBoard')}
              </Heading>
            </BreakPoint>

            <Suspense fallback={<Loading variant="details" />}>
              <ErrorHandler>
                <BulletinBoardDataLoader>
                  {({ bulletins, hasNextPage, onLoadMore }) => (
                    <BulletinBoardList
                      bulletins={bulletins}
                      hasNextPage={hasNextPage}
                      onLoadMore={onLoadMore}
                    />
                  )}
                </BulletinBoardDataLoader>
              </ErrorHandler>
            </Suspense>
          </>
        </View.Content>
      </View>
    </TitleController>
  )
}
